












































































import Vue, { PropType } from 'vue';
import Component, { mixins } from 'vue-class-component';

import { config } from './config';
import { locales } from './locales';

import { customizable, Options } from '../../mixins/customizable';
import { Eventable } from '../../mixins/eventable';
import { WarningRules } from '../../mixins/warningRules';

import { DateLogic } from './mixins/dateLogic';
import { MaskValue } from './mixins/maskValue';
import { Birthdate } from './mixins/birthdate';
import { PickerDate } from './mixins/pickerDate';
import { ErrorProp } from './mixins/errorProp';

import { mdiCalendar } from '@mdi/js';

import deepMerge from 'deepmerge';

const Props = Vue.extend({
	props: {
		/** Disable the calendar */
		noCalendar: {
			type: Boolean,
			default: false
		},
		/** Disable the prepend icon */
		noPrependIcon: {
			type: Boolean,
			default: false
		},
		/**
		 * Put VTextField in outlined mode,
		 * default to append icon and adjust VMenu
		 */
		outlined: {
			type: Boolean,
			default: false
		},
		/** Use append icon instead of prepend */
		appendIcon: {
			type: Boolean,
			default: false
		},
		/** Open calendar menu when the text field is clicked */
		textFieldActivator: {
			type: Boolean,
			default: false
		},
		/**
		 * Provide classes to the VTextField
		 * This is needed because classes are
		 * not contained in $attrs
		 */
		textFieldClass: {
			type: [String, Array] as PropType<string | string[]>,
			default: undefined
		}
	}
});

const MixinsDeclaration = mixins(
	Props,
	customizable(config),
	Eventable,
	WarningRules,
	DateLogic,
	MaskValue,
	Birthdate,
	PickerDate,
	ErrorProp
);

/**
 * DatePicker is a component that makes the date picker
 * from Vuetify simpler to use
 */
@Component<DatePicker>({
	inheritAttrs: false,
	model: {
		prop: 'value',
		event: 'change'
	}
})
export default class DatePicker extends MixinsDeclaration {
	// Locales
	locales = locales;

	// Icon
	calendarIcon = mdiCalendar;

	/** The v-model of VMenu */
	menu = false;

	get showAppendIcon(): boolean {
		return this.appendIcon || this.outlined;
	}

	get menuOptions(): Options {
		const position: Options = {
			nudgeBottom: this.outlined ? 56 : 45,
			nudgeRight: this.outlined ? 0 : 45
		};

		return deepMerge<Options>(position, this.options.menu);
	}

	/**
	 * Compute the options for the VTextField
	 * (Merge options and binded attributes)
	 *
	 * @returns {Options} Computed options
	 */
	get textFieldOptions(): Options {
		// Merge textField options (custom or default) with
		// directly binded attributes (theses attributes
		// will override 'options.textField')
		return deepMerge<Options>(this.options.textField, this.$attrs);
	}

	/**
	 * Compute the classes for the VTextField
	 * (Merge user classes and fixed behavior)
	 *
	 * @returns {string|string[]} Computed classes
	 */
	get textFieldClasses(): (string | string[])[] {
		const textFieldClasses = [];

		if (this.warningRules.length) {
			textFieldClasses.push('vd-warning-rules');
		}

		if (this.textFieldClass) {
			if (typeof this.textFieldClass === 'object') {
				textFieldClasses.push(this.textFieldClass);
			} else {
				textFieldClasses.push([this.textFieldClass]);
			}
		}

		return textFieldClasses;
	}

	/**
	 * Open calendar menu if textFieldActivator is true
	 *
	 * @returns {void}
	 */
	textFieldClicked(): void {
		if (this.textFieldActivator) {
			this.menu = true;
		}
	}
}
